import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuditLog } from '../models/auditLog';
import { PaginatedResponse } from '../models/paginatedResponse';
import { AuditLogSearchRequest } from '../models/api/auditLogSearchRequest';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuditLogService {
  private http = inject(HttpClient);
  private apiUrl = `${environment.apiUrl}/AuditLog`;

  /**
   * POST /api/AuditLog/search
   * Search audit logs with filters, pagination and sorting.
   */
  searchAuditLogs(request: AuditLogSearchRequest): Observable<PaginatedResponse<AuditLog>> {
    return this.http.post<PaginatedResponse<AuditLog>>(`${this.apiUrl}/search`, request);
  }

  /**
   * GET /api/AuditLog/changeset/{changeSetId}
   * Returns every entry written in one save (the parent plus children changed alongside it).
   */
  getChangeSet(changeSetId: string): Observable<AuditLog[]> {
    return this.http.get<AuditLog[]>(`${this.apiUrl}/changeset/${changeSetId}`);
  }
}
